'use client'
import React from 'react'
import CustomLink from '../../customLink'
import MyImage from '../../myImage'
import PlayIocn from '@/assets/images/icon/play-icon.svg'
import { convertHMS } from '@/shared/utils'
import { ClockIcon } from '@/shared/Icons'

function VideoList({ categoryVideos }: { categoryVideos: any }) {
  return (
    <>
      {categoryVideos?.map((item: any, index: number) => {
        return (
          <div key={index} className="mb-[22px] md:mb-[26px] last:mb-0">
            <div className="flex items-center justify-between gap-4">
              <h6 className=" text-sm md:text-xl text-textOffWhite font-bold">{item?.sName}</h6>
              <CustomLink
                href={`/${item?.oSeo?.sSlug}`}
                className="text-sm font-bold text-subSectionText"
              >
                View all
              </CustomLink>
            </div>
            <div className="mt-3.5 md:mt-5 flex md:grid grid-cols-3 gap-4 md:gap-6 overflow-x-auto -mr-3 md:-mr-0 pr-3 md:pr-0">
              {item?.aVideos?.slice(0, 3).map((video: any, index: number) => {
                return (
                  <div
                    key={index}
                    className="w-[120px] min-w-[120px] md:min-w-full md:w-full relative group"
                  >
                    <CustomLink href={`/${video?.oSeo?.sSlug}`}>
                      <div className="relative md:h-[157px] h-[75px] rounded-lg overflow-hidden mb-2 lg:mb-3 group">
                        <span className=" absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 z-10 w-6 h-6 md:w-8 md:h-8">
                          <MyImage src={PlayIocn} width={28} height={28} alt="playiocn" />
                        </span>
                        <MyImage
                          width={303}
                          height={157}
                          className="absolute top-0 left-0 w-full h-full object-cover rounded-lg group-hover:scale-[1.1] transition-all duration-300"
                          src={video?.aThumbnails[1]?.sUrl}
                        />
                        <span className="bg-black/70 text-white inline-block py-1 px-2 absolute bottom-2.5 right-2.5 z-10 text-xxxs md:text-xs rounded font-semibold">
                          {convertHMS(video?.nDurationSeconds)}
                        </span>
                      </div>
                      <h6 className="text-textOffWhite text-xs md:text-base font-bold line-clamp-2 mb-1.5 group-hover:text-subSectionText">
                        {video?.sTitle}
                      </h6>
                    </CustomLink>
                    <p className="flex items-center gap-1 md:gap-1.5 text-xs text-textDselected">
                      <span className="w-3 h-3 md:w-3.5 md:h-3.5 flex flex-shrink-0 items-center justify-center">
                        <ClockIcon />
                      </span>
                      {convertHMS(video?.nDurationSeconds, true)}
                    </p>
                  </div>
                )
              })}
            </div>
          </div>
        )
      })}
    </>
  )
}

export default VideoList
